export default "__VITE_ASSET__BP3yF7PV__"